import useAlert from "../../util/useAlert";


export default function Alert() {
    const {text, type} = useAlert();

    if (text === '') {
        return <></>
    }

    return <div className="selfcare-page-content">
        <section className="selfcare-messages">
            <div className={`selfcare-message-${type} show`}>
                <p>{text}</p>
            </div>
        </section>
    </div>
}
